import { useEffect, useState } from 'react';

/**
 * The current time, refreshed every `intervalMs`.
 *
 * For anything whose look depends on the clock — an assignment turning late at midnight —
 * so it updates on screen without anyone refetching.
 */
const useNow = (intervalMs = 60_000) => {
    const [now, setNow] = useState(() => new Date());

    useEffect(() => {
        const timer = setInterval(() => setNow(new Date()), intervalMs);
        return () => clearInterval(timer);
    }, [intervalMs]);

    return now;
};

export default useNow;
